import React from 'react';

const BusinessUnitConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/organizationalsetup/jobstatus',
			component:React.lazy(() => import('./JobStatus')) 
        }
	]
};

export default BusinessUnitConfig;